import { render, staticRenderFns } from "./NotificationWalletShareModal.vue?vue&type=template&id=0daced64&scoped=true"
import script from "./NotificationWalletShareModal.vue?vue&type=script&lang=js"
export * from "./NotificationWalletShareModal.vue?vue&type=script&lang=js"
import style0 from "./NotificationWalletShareModal.vue?vue&type=style&index=0&id=0daced64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daced64",
  null
  
)

export default component.exports